<template>
  <div class="relative w-full h-full bg-gray-300">
    <div class="z-0 w-full h-full" ref="Map"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Map',
  props: {
    poi: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions([
      'toInitMap',
      'toApplyPoi',
    ]),
    init: async function () {
      await this.toInitMap(this.$refs.Map)

      if (this.poi) {
        await this.toApplyPoi()
      }
    }
  }
}
</script>
